import { allColors } from '@/components/Commons/Charts/_utils/colors'

let backgroundColors = [...allColors]

export default {
  methods: {
    generateBudgetDataset () {
      const data = this.generateBudgetDataSetStructure()
      let dataset = [...data]
      this.expenseDashboardData.forEach(el => {
        dataset.forEach(budgetInDataSet => {
          this.setBudgetInDataSetInformation(budgetInDataSet, el)
        })
      })
      return dataset
    },
    generateBudgetDataSetStructure () {
      let dashboardBudgets = []
      this.expenseDashboardData.forEach(dashboardItem => {
        this.processDashboardItemBudgets(dashboardItem.budgets, dashboardBudgets)
      })
      if (!this.budgetId) {
        this.setBudgetsColor(dashboardBudgets)
      }
      return dashboardBudgets.sort((a, b) => a.id - b.id)
    },
    processDashboardItemBudgets (budgets, dashboardBudgets) {
      if (budgets) {
        budgets.forEach(budget => {
          if (budget.budgetId) {
            const isBudgetInDashboardBudgets = dashboardBudgets.find(
              el => el.id === budget.budgetId
            )
            if (!isBudgetInDashboardBudgets) {
              const newBudgetData = this.createBudgetModel(budget, 'BUDGET')
              dashboardBudgets.push(newBudgetData)
            }
          } else {
            const isReimbursementsInDashboardBudgets = dashboardBudgets.find(
              el => el.label === 'Gastos'
            )
            if (!isReimbursementsInDashboardBudgets) {
              const reimbursementsData = this.createBudgetModel(
                null,
                'REIMBURSEMENT'
              )
              dashboardBudgets.push(reimbursementsData)
            }
          }
        })
      }
    },
    createBudgetModel (budget, budgetType) {
      return {
        id: budgetType === 'BUDGET' ? budget.budgetId : null,
        label: budgetType === 'BUDGET' ? budget.budgetName : 'Gastos',
        data: [],
        dates: [],
        backgroundColor: budgetType === 'BUDGET' ? '#0089f2' : 'lightgray',
        borderWidth: 0.75,
        dataType: 'BUDGET'
      }
    },
    setBudgetInDataSetInformation (budgetFromDataset, currentDateItems) {
      const isBudgetInCurrentDateBudgetList = currentDateItems.budgets.find(
        el => el.budgetId === budgetFromDataset.id
      )
      if (isBudgetInCurrentDateBudgetList) {
        budgetFromDataset.data.push(
          Number.parseFloat(
            (
              Math.round(isBudgetInCurrentDateBudgetList.totalAmount * 100) /
              100
            ).toFixed(2)
          )
        )
        budgetFromDataset.dates.push(currentDateItems.dateSum)
      } else {
        budgetFromDataset.data.push(0)
        budgetFromDataset.dates.push(currentDateItems.dateSum)
      }
    },

    setBudgetsColor (dashboardBudgets) {
      dashboardBudgets.forEach((el, index) => {
        let randomColorIndex = Math.floor(
          Math.random() * backgroundColors.length
        )
        let previousIndex = index - 1

        if (previousIndex >= 0 && el.id) {
          const selectedRandomColor = backgroundColors[randomColorIndex]
          if (
            dashboardBudgets[previousIndex].backgroundColor ===
            selectedRandomColor
          ) {
            let backgroundColorsWithoutSelectedRandomColor = backgroundColors.filter(
              el => el !== selectedRandomColor
            )
            let newRandomColor =
              backgroundColorsWithoutSelectedRandomColor[Math.floor(Math.random() * backgroundColorsWithoutSelectedRandomColor.length)]
            el.backgroundColor = newRandomColor
          } else {
            el.backgroundColor = selectedRandomColor
          }
        } else {
          if (el.id) {
            el.backgroundColor = backgroundColors[randomColorIndex]
          }
        }
        if (dashboardBudgets.length <= backgroundColors.length) {
          backgroundColors.splice(randomColorIndex, 1)
        }
      })
    }
  }
}
